<template>
  <div class="question-selector">
    <!-- 问题标题 -->
    <div class="question-title">
      {{ $t('Gattaran_Feedback_aSQV_CWCu' /** 你需要什么帮助？ */) }}
    </div>
    <pb-cascader
      v-model="selectedQuestion"
      :options="questionList"
      :placeholder="$t('Gattaran_Feedback__vYiO' /** 请选择 */)"
      @change="handleQuestionChange"
    />
    <!-- 运营咨询类二维码提示 -->
    <div v-if="currentSelectedQuestion.dcQrcode" class="qr-code-section">
      <div class="qr-code-tip">
        {{
          $t(
            'Gattaran_Feedback_oHQm_chDu' /** 请进下面这个DChat群反馈问题细节，以便运营团队为您提供支持 */,
          )
        }}
      </div>
      <img :src="currentSelectedQuestion.dcQrcode" alt="QR Code" class="qr-code-image" />
      <div class="qr-code-link">
        <a :href="currentSelectedQuestion.dcLink" target="_blank">{{
          currentSelectedQuestion.dcLink
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getQuestionList } from '../config'

export default {
  name: 'QuestionSelector',
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    onQuestionChange: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      selectedQuestion: [],
      questionList: getQuestionList(),
    }
  },
  computed: {
    // 二维码图片
    currentSelectedQuestion() {
      const [type, value] = this.selectedQuestion || []
      const currentQuestionGroup = this.questionList.find(q => q.value === type)
      const currentQuestionItem = currentQuestionGroup?.children.find(c => c.value === value) || {}
      return currentQuestionItem
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val && val.questionValue && val.questionCategory) {
          this.selectedQuestion = [val.questionCategory, val.questionValue]
        } else {
          this.selectedQuestion = []
        }
      },
    },
  },
  methods: {
    handleQuestionChange(item) {
      const [questionCategory, questionValue] = item || []
      // 触发表单值变化
      // ticketType 就是后端需要的 questionType 值（'1'/'2'/'3'/'4'）
      // questionCategory 是前端用来判断问题大类的（'operation'/'product'/'tech'）
      this.$emit('change', {
        questionValue,
        questionType: this.currentSelectedQuestion?.ticketType, // 后端需要的工单类型
        questionCategory,
      })
      // 回调通知父组件问题类型变化
      if (this.onQuestionChange) {
        this.onQuestionChange(questionCategory)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.question-selector {
  padding: 0;
}

.question-title {
  font-size: 14px;
  font-weight: 500;
  color: #282b33;
  margin-bottom: 16px;
  line-height: 22px;
}

.question-group {
  margin-bottom: 8px;
}

.question-divider {
  height: 16px;
}

.question-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  margin-bottom: 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #f7f8fa;

  &:hover {
    background: #f0f1f5;
  }

  &.active {
    background: #fff7f4;
    border: 1px solid #f76a31;
  }
}

.radio-circle {
  width: 16px;
  height: 16px;
  border: 1px solid #c9cdd4;
  border-radius: 50%;
  margin-right: 8px;
  position: relative;
  flex-shrink: 0;

  &.checked {
    border-color: #f76a31;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #f76a31;
    }
  }
}

.question-text {
  font-size: 14px;
  color: #282b33;
  line-height: 22px;
}

.qr-code-section {
  margin-top: 24px;
  padding: 16px;
  background: #f7f8fa;
  border-radius: 8px;
  text-align: center;
}

.qr-code-tip {
  font-size: 14px;
  color: #5a5e66;
  margin-bottom: 16px;
  line-height: 22px;
}

.qr-code-image {
  max-width: 200px;
  height: auto;
  border-radius: 4px;
}

.qr-code-link {
  margin-top: 12px;
  word-break: break-all;

  a {
    font-size: 12px;
    color: #f76a31;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
